export default {
      id: "icon--snowflake-loading-usage",
      viewBox: "0 0 26.7 31",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--snowflake-loading-usage",
      toString: function () {
        return this.url;
      }
    }